import { FilterType } from "src/api/types";
import ProductFilter from "src/components/ProductFilter";
import { PRODUCT } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: PRODUCT,
    placeholder: "Product",
    type: "custom",
    component: ProductFilter,
  },
];
